import { logVerboseUsage } from 'owa-analytics';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';

export default function logFolderPaneState(
    layoutChangeSource: LayoutChangeSource,
    folderPaneNewShowState: boolean,
    folderPaneOldShowState: boolean
) {
    logVerboseUsage('TnS_FolderPaneChange', [
        layoutChangeSource.toString(),
        folderPaneNewShowState,
        folderPaneOldShowState,
    ]);
}
